import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'HeaderAndCTA',
})(({ spacing, breakpoints, typography }) => ({
  optionalCTAGrid: {
    display: 'flex',
    marginTop: typography.pxToRem(-16),
    justifyContent: 'start',
    [breakpoints.up('md')]: {
      marginTop: spacing(3),
      justifyContent: 'end',
    },
    '&.MuiGrid2-root': { marginBottom: spacing(3) },
  },
  optionalCTAContainer: {
    display: 'flex',
    alignSelf: 'end',
  },
}));

export default useStyles;
